export default {
  COMPANY: 'company',
  CUSTOMER: 'customer'
};